import { render, staticRenderFns } from "./customerCompany.vue?vue&type=template&id=490c9252&scoped=true&"
import script from "./customerCompany.vue?vue&type=script&lang=js&"
export * from "./customerCompany.vue?vue&type=script&lang=js&"
import style0 from "./customerCompany.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customerCompany.vue?vue&type=style&index=1&id=490c9252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c9252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490c9252')) {
      api.createRecord('490c9252', component.options)
    } else {
      api.reload('490c9252', component.options)
    }
    module.hot.accept("./customerCompany.vue?vue&type=template&id=490c9252&scoped=true&", function () {
      api.rerender('490c9252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/advertisement/customerCompany.vue"
export default component.exports